import { Grid, Modal, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import Box from '@mui/material/Box';
import { useMediaQueryState } from 'hooks/useMediaQueryState';
import TaskGradeEditPageStore from '../store/TaskGradeEditStore';
import CloseIcon from '@mui/icons-material/Close';
import outlookIcon from '../../../assets/image/outlookIcon.svg';

interface HTMLContentAssessModalProps {
  pageStore?: TaskGradeEditPageStore;
  isOpen: boolean;
  handleClose: () => void;
  onClickCancel?: () => void;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '15px',
  paddingTop: '40px',
  paddingBottom: '20px',
  paddingLeft: '20px',
  paddingRight: '20px',
  minWidth: '335px',
};

function HTMLContentAssessModal(props: HTMLContentAssessModalProps) {
  const { pageStore, handleClose } = props;
  const { isPC } = useMediaQueryState();
  return (
    <Modal open={props.isOpen} onClose={props.handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
      <Box sx={style}>
        {pageStore?.task?.subtype === 'EMAIL' ? (
          <Grid container alignItems={'center'} style={{ marginBottom: '10px' }}>
            <Grid item xs={1}>
              <img src={outlookIcon} width='20px' height='20px' alt='outlookIcon' />
            </Grid>
            <Grid item xs={11}>
              <Typography
                style={{
                  fontStyle: 'normal',
                  fontWeight: 700,
                  fontSize: '18px',
                  lineHeight: '18px',
                  color: '#171918',
                }}
              >
                {pageStore?.task.title}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
        <div
          style={{
            maxHeight: isPC ? '500px' : '300px',
            maxWidth: isPC ? '500px' : '330px',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            overflow: 'scroll',
          }}
          dangerouslySetInnerHTML={{
            __html: pageStore?.task?.userData?.body?.content as any,
          }}
        ></div>
        <CloseIcon sx={{ position: 'absolute', right: '18px', top: '18px', cursor: 'pointer' }} onClick={handleClose} />
      </Box>
    </Modal>
  );
}

export default observer(HTMLContentAssessModal);
